import { AnyRoute } from '@tanstack/react-router';
import { createRoutesFromConfig, RouteConfig } from './routeHelpers';
import { SingleDegreePage } from '@new/features/degree/pages/SingleDegreePage';
import { DegreesListPage } from '@new/features/degree/pages/DegreesListPage';
import { ProtectedRoute } from '@new/casl/components/ProtectedRoute';
import { SingleCoursePage } from '@new/features/courses/pages/SingleCoursePage';
import { LessonDetailPage } from '@new/features/lessons/pages/LessonDetailPage';
import { ObjectiveDetailPage } from '@new/features/objectives/pages/ObjectiveDetailPage';
import LessonEdit from '@screens/lessons/LessonEdit';
import ObjectiveEdit from '@screens/objectives/ObjectiveEdit';

export function createDegreeRoutes(parent: AnyRoute) {
  const degreeConfigs: RouteConfig[] = [
    {
      path: 'degrees',
      component: () => (
        <ProtectedRoute action="access" subject="DegreeList">
          <DegreesListPage />
        </ProtectedRoute>
      ),
    },
    {
      path: 'degrees/$degreeId',
      component: SingleDegreePage,
    },
    {
      path: 'degrees/$degreeId/courses/$courseId',
      component: SingleCoursePage,
    },
    {
      path: 'degrees/$degreeId/courses/$courseId/lessons/$lessonId',
      component: LessonDetailPage,
    },
    {
      path: 'degrees/$degreeId/courses/$courseId/lessons/$lessonId/objectives/$objectiveId',
      component: ObjectiveDetailPage,
    },
    {
      path: 'degrees/$degreeId/courses/$courseId/lessons/$lessonId/edit',
      component: LessonEdit,
    },
    {
      path: 'degrees/$degreeId/courses/$courseId/lessons/$lessonId/objectives/$objectiveId/edit',
      component: ObjectiveEdit,
    },
  ];

  return createRoutesFromConfig(parent, degreeConfigs);
}
